import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { _UserService } from './services/user.service';

declare var $:any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{
  title = 'WiseRisk';
  constructor( private translate: TranslateService, private router: Router, private user: _UserService ) {
    translate.setDefaultLang('en');
    translate.use('en');
  }
  ngOnInit() {
    // This is the jquery http interceptor. It is currently required because there are
    // serveral pages using jquery AJAX to get resources or post to the server
    // (sometimes) exclusively, or use JQWidgets' built in jquery AJAX calls.
    // After said pages are ported to angular, this will no longer be used.
    $( document ).ajaxError((esvent, jqxhr, settings, thrownError) => {
      if (jqxhr.status === 401 && window.location.pathname !=="/login") {
        this.user.logout();
        this.router.navigateByUrl('/login')
      }
    });
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/app.component.ts